import { Link, useForm, usePage } from "@inertiajs/react";
import Header from "./Component/Header";
import Footer from "./Component/Footer";

export default function SystemLogin() {
    const { flash } = usePage().props;
    const { data, setData, post, processing, errors, reset } = useForm({
        email: "",
        password: "",
    });

    const submit = (e) => {
        e.preventDefault();

        post("/authenticate", {
            onFinish: () => reset("password"),
        });
    };

    return (
        <>
            <Header />
            <main id="content" className="max-w-6xl px-4 sm:px-6 lg:px-8 mx-auto py-8 sm:py-12 min-h-[calc(100vh-180px)]">
                <div className="max-w-xl mx-auto rounded-xl border border-card-line bg-card p-6 sm:p-8 shadow-2xs">
                    <div className="mb-6">
                        <h1 className="text-xl font-semibold text-foreground">Masuk</h1>
                        <p className="mt-1 text-sm text-muted-foreground-1">
                            Gunakan akun Anda untuk melanjutkan.
                        </p>
                    </div>

                    {flash?.success && (
                        <div className="mb-4 rounded-lg border border-green-200 bg-green-50 px-3 py-2 text-sm text-green-700">
                            {flash.success}
                        </div>
                    )}

                    <form onSubmit={submit} className="space-y-4">
                        <div>
                            <label htmlFor="system-login-email" className="mb-1.5 block text-sm font-medium text-foreground">
                                Email
                            </label>
                            <input
                                id="system-login-email"
                                type="email"
                                value={data.email}
                                onChange={(e) => setData("email", e.target.value)}
                                className="py-2.5 px-3 block w-full rounded-lg border border-layer-line bg-layer text-layer-foreground placeholder:text-muted-foreground-1 focus:border-primary-focus focus:ring-primary-focus"
                                placeholder="you@example.com"
                                autoComplete="off"
                            />
                            {errors.email && <p className="mt-1 text-xs text-red-600">{errors.email}</p>}
                        </div>

                        <div>
                            <label htmlFor="system-login-password" className="mb-1.5 block text-sm font-medium text-foreground">
                                Kata Sandi
                            </label>
                            <input
                                id="system-login-password"
                                type="password"
                                value={data.password}
                                onChange={(e) => setData("password", e.target.value)}
                                className="py-2.5 px-3 block w-full rounded-lg border border-layer-line bg-layer text-layer-foreground placeholder:text-muted-foreground-1 focus:border-primary-focus focus:ring-primary-focus"
                                placeholder="Masukkan kata sandi"
                            />
                            {errors.password && (
                                <p className="mt-1 text-xs text-red-600">{errors.password}</p>
                            )}
                        </div>
                        <div className="flex flex-wrap flex-row-reverse gap-3">
                            <Link href="/forgot-password" className="font-medium text-primary hover:underline">
                                Lupa kata sandi
                            </Link>
                        </div>

                        <button
                            type="submit"
                            disabled={processing}
                            className="w-full inline-flex justify-center items-center rounded-lg border border-primary-line bg-primary px-4 py-2.5 text-sm font-medium text-primary-foreground hover:bg-primary-hover disabled:opacity-50 disabled:pointer-events-none"
                        >
                            {processing ? "Sedang masuk..." : "Masuk"}
                        </button>
                    </form>

                    <p className="mt-4 text-sm text-muted-foreground-1">
                        Belum punya akun?{" "}
                        <Link href="/sign-up" className="font-medium text-primary hover:underline">
                            Daftar sekarang
                        </Link>
                    </p>
                </div>
            </main>
            <Footer />
        </>
    );
}
